import {
  ascend,
  map,
  min,
  pipe,
  prop,
  reduce,
  sortWith,
} from 'ramda';

import type { LobbyTable } from '../types/table';

/**
 * Sort tables in ascending order by their smallest `Min_Bet`.
 * Tables having the same smallest `Min_Bet` are sorted in ascending order by their smallest `Max_Bet`.
 * This sorting is applied when BO config `tables_sorting_type` is `limits`
 */
export const sortTablesByLimits = sortWith<LobbyTable>([
  ascend(pipe(prop('limits'), map(prop('minBet')), reduce(min, Infinity))),
  ascend(pipe(prop('limits'), map(prop('maxBet')), reduce(min, Infinity))),
]);
